import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Close from '@mui/icons-material/Close';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import { IconButton, styled, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { SnackbarAction, SnackbarKey, SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import { createRef, FunctionComponent, ReactNode } from 'react';

const StyledNotistackSnackbarProvider = styled(NotistackSnackbarProvider)`
  &.SnackbarContent-root {
    max-width: 25rem;
    display: flex;
    flex-wrap: nowrap;
    color: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.common.black};

    .SnackbarItem-message {
      svg {
        margin-right: 1rem;
      }
    }
  }

  &.SnackbarItem-variantError {
    background-color: ${({ theme }) => theme.palette.common.black};
    color: ${({ theme }) => theme.palette.common.white};
  }

  &.SnackbarItem-variantInfo {
    background-color: ${({ theme }) => theme.palette.common.black};
    color: ${({ theme }) => theme.palette.common.white};
  }

  &.SnackbarItem-variantWarning {
    background-color: ${({ theme }) => theme.palette.common.black};
    color: ${({ theme }) => theme.palette.common.white};
  }

  &.SnackbarItem-variantSuccess {
    background-color: ${({ theme }) => theme.palette.common.black};
    color: ${({ theme }) => theme.palette.common.white};
  }
`;

export const SnackbarProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const notistackRef = createRef<NotistackSnackbarProvider>();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('lg'));

  function handleClose(key: SnackbarKey) {
    if (!notistackRef.current) return;

    notistackRef.current.closeSnackbar(key);
  }

  const dismissAction: SnackbarAction = (key) => {
    return (
      <IconButton size="large" color="inherit" aria-label="close" onClick={() => handleClose(key)}>
        <Close />
      </IconButton>
    );
  };

  return (
    <StyledNotistackSnackbarProvider
      ref={notistackRef}
      action={dismissAction}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: isMobile ? 'center' : 'right',
      }}
      iconVariant={{
        info: <InfoOutlined color="info" />,
        error: <ErrorOutline color="error" />,
        warning: <ReportProblemOutlined color="warning" />,
        success: <CheckCircleOutline color="success" />,
      }}
    >
      {children}
    </StyledNotistackSnackbarProvider>
  );
};
